// phonics_data_ss.js
// Song/Chant 来源: F:\BaiduNetdiskDownload\Phonics\Ss.mp4 (用户指定，时间段 00:12~01:30)
// Story 1/2/3 来源: F:\17talkxyz\Phonics_AtoZ\Letter Ss\Ss1/Ss2/Ss3.mp4 (完整)

const MEDIA_BASE = '/media/phonics/ss';

const letterDataSs = {
  letter: 'Ss',
  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/Ss.png`,

  songVideo: {
    src: `${MEDIA_BASE}/Ss.mp4`,
    poster: `${MEDIA_BASE}/Ss.png`,
    startTime: 12,
    endTime: 90,
  },

  wordVideos: [
    { src: `${MEDIA_BASE}/video_s3_word1.mp4`, poster: `${MEDIA_BASE}/image8.png`, word: 'sea', wordCn: '大海' },
    { src: `${MEDIA_BASE}/video_s3_word2.mp4`, poster: `${MEDIA_BASE}/image9.png`, word: 'sun', wordCn: '太阳' },
    { src: `${MEDIA_BASE}/video_s3_word3.mp4`, poster: `${MEDIA_BASE}/image10.png`, word: 'sock', wordCn: '袜子' },
    { src: `${MEDIA_BASE}/video_s3_word4.mp4`, poster: `${MEDIA_BASE}/image11.png`, word: 'sandwich', wordCn: '三明治' },
  ],

  storySections: [
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_sea.mp4`, poster: `${MEDIA_BASE}/image13.png` },
      ],
      splitAt: 3,
      lines: [
        {
          en: 'went',
          cn: '去',
          audioEn: `${MEDIA_BASE}/w_en_went.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_went.mp3`,
        },
        {
          en: 'there is',
          cn: '有',
          audioEn: `${MEDIA_BASE}/w_en_there_is.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_there_is.mp3`,
        },
        {
          en: 'splash',
          cn: '溅水的声音',
          audioEn: `${MEDIA_BASE}/w_en_splash.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_splash.mp3`,
        },
        {
          en: 'Sam went to sea.',
          cn: 'Sam出海。',
          audioEn: `${MEDIA_BASE}/story1_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story1_cn_1.mp3`,
        },
        {
          en: 'There is the sun.',
          cn: '有太阳。',
          audioEn: `${MEDIA_BASE}/story1_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story1_cn_2.mp3`,
        },
        {
          en: 'Oh, no! Where is the sun?',
          cn: '太阳哪儿去了？',
          audioEn: `${MEDIA_BASE}/story1_en_3.mp3`,
          audioCn: `${MEDIA_BASE}/story1_cn_3.mp3`,
        },
      ],
    },
    {
      label: 'Learn the Story (2)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_sandwich.mp4`, poster: `${MEDIA_BASE}/image14.png` },
      ],
      splitAt: 1,
      lines: [
        {
          en: 'here is',
          cn: '这是',
          audioEn: `${MEDIA_BASE}/w_en_here_is.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_here_is.mp3`,
        },
        {
          en: 'Here is my sandwich.',
          cn: '这是我的三明治。',
          audioEn: `${MEDIA_BASE}/story2_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story2_cn_1.mp3`,
        },
        {
          en: 'Oh, no! My sandwich.',
          cn: '噢不！我的三明治。',
          audioEn: `${MEDIA_BASE}/story2_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story2_cn_2.mp3`,
        },
      ],
    },
    {
      label: 'Learn the Story (3)',
      layout: 'video-left-vocab-right',
      videos: [
        { src: `${MEDIA_BASE}/video_story_sad.mp4`, poster: `${MEDIA_BASE}/image15.png` },
      ],
      splitAt: 1,
      lines: [
        {
          en: 'sad',
          cn: '伤心难过',
          audioEn: `${MEDIA_BASE}/w_en_sad.mp3`,
          audioCn: `${MEDIA_BASE}/w_cn_sad.mp3`,
        },
        {
          en: 'Here are my socks.',
          cn: '这是我的袜子。',
          audioEn: `${MEDIA_BASE}/story3_en_1.mp3`,
          audioCn: `${MEDIA_BASE}/story3_cn_1.mp3`,
        },
        {
          en: 'Oh, no! My socks.',
          cn: '噢不！我的袜子。',
          audioEn: `${MEDIA_BASE}/story3_en_2.mp3`,
          audioCn: `${MEDIA_BASE}/story3_cn_2.mp3`,
        },
        {
          en: 'Sam is sad.',
          cn: 'Sam很伤心。',
          audioEn: `${MEDIA_BASE}/story3_en_3.mp3`,
          audioCn: `${MEDIA_BASE}/story3_cn_3.mp3`,
        },
      ],
    },
  ],
};

export default letterDataSs;
